import React, { PropsWithChildren } from 'react'
import {
  NavLink as ReactRouterNavLink,
  NavLinkProps as ReactRouterNavLinkProps
} from 'react-router-dom'

type NavLinkProps = ReactRouterNavLinkProps &
  React.RefAttributes<HTMLAnchorElement>

/**
 * An anchor that is linking to a route inside a navigation.
 * If you want to use this outside a navigation, use RouterLink instead.
 *
 * @param children
 * @param className
 * @param props
 * @constructor
 */
export default function RouterNavLink({
  children,
  className,
  ...props
}: PropsWithChildren<NavLinkProps>) {
  const classNames = ['elm-link', className].join(' ').trim()

  return (
    <ReactRouterNavLink className={classNames} {...props}>
      {children}
    </ReactRouterNavLink>
  )
}
